import { render, staticRenderFns } from "./language_setting.vue?vue&type=template&id=5220e94e&scoped=true&"
import script from "./language_setting.vue?vue&type=script&lang=js&"
export * from "./language_setting.vue?vue&type=script&lang=js&"
import style0 from "./language_setting.vue?vue&type=style&index=0&id=5220e94e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5220e94e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5220e94e', component.options)
    } else {
      api.reload('5220e94e', component.options)
    }
    module.hot.accept("./language_setting.vue?vue&type=template&id=5220e94e&scoped=true&", function () {
      api.rerender('5220e94e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/menu_common/language_setting.vue"
export default component.exports